module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "vm-pager",
    on: {
      "click": _vm.onPagerClick
    }
  }, [(_vm.pageCount > 0) ? _c('li', {
    staticClass: "number",
    class: {
      active: _vm.currentPage === 1
    }
  }, [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.showPrevMore) ? _c('li', {
    staticClass: "vm-page-icon more btn-quickprev",
    class: [_vm.quickprevIconClass],
    on: {
      "mouseenter": function($event) {
        _vm.quickprevIconClass = 'vm-page-icon-d-arrow-left'
      },
      "mouseleave": function($event) {
        _vm.quickprevIconClass = 'vm-page-icon-more'
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.pagers), function(pager) {
    return _c('li', {
      staticClass: "number",
      class: {
        active: _vm.currentPage === pager
      }
    }, [_vm._v(_vm._s(pager))])
  }), _vm._v(" "), (_vm.showNextMore) ? _c('li', {
    staticClass: "vm-page-icon more btn-quicknext",
    class: [_vm.quicknextIconClass],
    on: {
      "mouseenter": function($event) {
        _vm.quicknextIconClass = 'vm-page-icon-d-arrow-right'
      },
      "mouseleave": function($event) {
        _vm.quicknextIconClass = 'vm-page-icon-more'
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.pageCount > 1) ? _c('li', {
    staticClass: "number",
    class: {
      active: _vm.currentPage === _vm.pageCount
    }
  }, [_vm._v(_vm._s(_vm.pageCount))]) : _vm._e()], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0953258c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0953258c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pager.vue
// module id = 20
// module chunks = 0